<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="4">
        <span class="red--text">{{error}}</span>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="4">
        <v-text-field
            validate-on-blur
            :rules="rules"
            v-model="username"
            class="text-input-black"
            label="e-mail"
            @keyup.enter="login">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="4">
        <v-text-field
            validate-on-blur
            :rules="rules"
            v-model="password"
            class="text-input-black"
            type="password"
            label="heslo"
            @keyup.enter="login">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col class="text-center" cols="12">
        <v-btn @click="login()"
        color="accent" 
        >
          prihlásiť
        </v-btn>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
  import axios from 'axios';
  import store from "../../store/store";

  export default {
  name: "Login",
  props: ['refForm'],  
  data: () => ({
    rules: [
      value => !!value || 'Vyplňte prosím toto pole.'
    ],
        username: '',
        password: '',
        error: ''
  }),
  watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 3000)
    },
  },
  computed: {
    winHeight(){
      return window.innerHeight;
    }
  },
  methods: {
    login(){
      this.loginClicked = true;
      if(!this.refForm.validate()) return;
      this.error = '';
      const params = new URLSearchParams();
      params.append('username', this.username);
      params.append('password', this.password);
      axios({
        method: 'post',
        url: store.state.url.concat('login.php'),
        data: params
      }).then((response) => {
        if(response.data.result == 'ok') {
          store.commit("setLoggedUser", {
            name:response.data.name, surname: response.data.surname, id:response.data.id
          });
          this.loggedIn = true;
          localStorage.setItem('loggedUserName', response.data.name);
          localStorage.setItem('loggedUserSurname', response.data.surname);
          localStorage.setItem('loggedUserId', response.data.id);
          localStorage.setItem('isLogged', 'logged');
          this.$router.push({name: 'userDashboard'});
        }else{
          this.error = response.data.error;
        }
      });

    }
  }
}
</script>

<style scoped>

</style>